import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Settings, Users2, Shield, BookOpen, Palette, Building2, UserPlus, ScrollText, Warehouse } from "lucide-react";
import TeamPage from "@/pages/TeamPage";
import SistemaPage from "@/pages/SistemaPage";
import AuditoriaPage from "@/pages/AuditoriaPage";
import MapeosReferenciaPage from "@/pages/MapeosReferenciaPage";
import ColoresCatalogoPage from "@/pages/ColoresCatalogoPage";
import EmpresaPage from "@/pages/EmpresaPage";
import BodegaRutaPage from "@/pages/BodegaRutaPage";

const TABS = [
  { key: "equipo", label: "Equipo y permisos", icon: Users2, Component: TeamPage, testid: "tab-equipo" },
  { key: "empresa", label: "Datos de empresa", icon: Building2, Component: EmpresaPage, testid: "tab-empresa" },
  { key: "bodega", label: "Ruta de bodega", icon: Warehouse, Component: BodegaRutaPage, testid: "tab-bodega" },
  { key: "mapeos", label: "Diccionario de referencias", icon: BookOpen, Component: MapeosReferenciaPage, testid: "tab-mapeos" },
  { key: "colores", label: "Diccionario de colores", icon: Palette, Component: ColoresCatalogoPage, testid: "tab-colores" },
  { key: "sistema", label: "Sistema y backups", icon: Shield, Component: SistemaPage, testid: "tab-sistema" },
  { key: "auditoria", label: "Auditoría", icon: ScrollText, Component: AuditoriaPage, testid: "tab-auditoria" },
];

export default function ConfiguracionHubPage() {
  const [tab, setTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("tab") || "equipo";
  });
  const [pendingCount, setPendingCount] = useState(0);
  // Nov/2026: si la URL cambia (KPI → /finanzas?tab=x estando ya en el hub), seguir el tab
  const _loc = useLocation();
  useEffect(() => {
    const t = new URLSearchParams(_loc.search).get("tab");
    if (t && t !== tab) setTab(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_loc.search]);
  const setTabAndUrl = (t) => {
    setTab(t);
    const url = new URL(window.location);
    url.searchParams.set("tab", t);
    window.history.replaceState({}, "", url);
  };
  const Active = TABS.find((t) => t.key === tab) || TABS[0];

  // Contador de solicitudes pendientes (para el badge en el tab)
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/team/pending");
        if (alive) setPendingCount((data || []).length);
      } catch { /* ignora */ }
    };
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [tab]);

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-4xl font-display font-bold text-foreground flex items-center gap-3">
          <Settings className="w-8 h-8 text-primary" /> Configuración
        </h1>
      </header>

      <div className="flex gap-1 mb-6 border-b border-border overflow-x-auto">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTabAndUrl(t.key)}
            className={`px-4 py-3 text-sm font-semibold border-b-2 transition-all flex items-center gap-2 whitespace-nowrap relative ${
              tab === t.key ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
            }`}
            data-testid={t.testid}
          >
            <t.icon className="w-4 h-4" /> {t.label}
            {t.showBadge && pendingCount > 0 && (
              <span className="ml-1 min-w-[20px] h-5 px-1.5 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center" data-testid="solicitudes-badge">
                {pendingCount > 99 ? "99+" : pendingCount}
              </span>
            )}
          </button>
        ))}
      </div>

      <div className="hub-embedded hub-embedded-sub"><Active.Component embedded={true} /></div>
    </div>
  );
}
